export const monthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const getDateShort = (date: Date, verbal = true, withTime = false): string => {
  // getMonth() gives us from 0 to 11
  const months = twoNumFormat(date.getMonth() + 1);
  const days = twoNumFormat(date.getDate());
  const year = date.getFullYear();

  if (verbal) {
    return `${monthsShort[date.getMonth()]} ${days}, ${year}`;
  }
  return `${months}/${days}/${year}`; // For example: 01/23/2021
};

export const twoNumFormat = (number) => number.toString().padStart(2, '0');

/**
 * Absolute date + time, e.g. "Mar 4, 2026, 2:31 PM".
 * Used for message timestamps where the exact time matters.
 */
export const getDateTimeShort = (timestamp: number): string =>
  new Date(timestamp).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
